import { render } from "./GatePassView.vue?vue&type=template&id=0016cdd8&scoped=true"
import script from "./GatePassView.vue?vue&type=script&lang=js"
export * from "./GatePassView.vue?vue&type=script&lang=js"

import "./GatePassView.vue?vue&type=style&index=0&id=0016cdd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0016cdd8"]])

export default __exports__